import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './routes';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { BrowserEventBusService } from './services/event-bus.service';
import { authInterceptorFn } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptorFn])
    ),
    provideAppInitializer(() => {
      inject(BrowserEventBusService);
    }),
  ],
};
